import { render } from "./base-toggle.vue?vue&type=template&id=0f64d554&scoped=true&ts=true"
import script from "./base-toggle.vue?vue&type=script&lang=ts"
export * from "./base-toggle.vue?vue&type=script&lang=ts"

import "./base-toggle.vue?vue&type=style&index=0&id=0f64d554&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f64d554"]])

export default __exports__